/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface UserTheme
 */
export interface UserTheme {
    /**
     *
     * @type {string}
     * @memberof UserTheme
     */
    primaryColor?: string;
    /**
     *
     * @type {string}
     * @memberof UserTheme
     */
    secondaryColor?: string;
    /**
     *
     * @type {boolean}
     * @memberof UserTheme
     */
    dark?: boolean;
}

export function UserThemeFromJSON(json: any): UserTheme {
    return UserThemeFromJSONTyped(json, false);
}

export function UserThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTheme {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        primaryColor: !exists(json, 'primaryColor') ? undefined : json['primaryColor'],
        secondaryColor: !exists(json, 'secondaryColor') ? undefined : json['secondaryColor'],
        dark: !exists(json, 'dark') ? undefined : json['dark'],
    };
}

export function UserThemeToJSON(value?: UserTheme | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        primaryColor: value.primaryColor,
        secondaryColor: value.secondaryColor,
        dark: value.dark,
    };
}
